module.exports = __webpack_public_path__ + "files/40f4221aa0bafc6706909917efd571e4.svg";